var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71664 10.8059H7.46664C7.46664 10.6349 7.4082 10.469 7.30101 10.3358L6.71664 10.8059ZM1.44544 4.25365L2.02981 3.78353L2.02981 3.78353L1.44544 4.25365ZM16.5833 4.21668L15.9881 3.76042L15.9881 3.76042L16.5833 4.21668ZM11.6492 10.654L11.054 10.1978C10.9536 10.3287 10.8992 10.4891 10.8992 10.654H11.6492ZM11.6492 18.3269L12.0066 18.9863C12.2485 18.8552 12.3992 18.6021 12.3992 18.3269H11.6492ZM6.71664 21H5.96664C5.96664 21.2644 6.10579 21.5092 6.33291 21.6444C6.56003 21.7797 6.84158 21.7854 7.07398 21.6594L6.71664 21ZM7.30101 10.3358L2.02981 3.78353L0.86107 4.72376L6.13227 11.276L7.30101 10.3358ZM2.02981 3.78353C1.37182 2.96563 1.95405 1.75 3.00376 1.75V0.25C0.694383 0.25 -0.586506 2.92438 0.86107 4.72376L2.02981 3.78353ZM3.00376 1.75H14.996V0.25H3.00376V1.75ZM14.996 1.75C16.0321 1.75 16.6184 2.9381 15.9881 3.76042L17.1786 4.67293C18.5652 2.86381 17.2754 0.25 14.996 0.25V1.75ZM15.9881 3.76042L11.054 10.1978L12.2445 11.1103L17.1786 4.67293L15.9881 3.76042ZM10.8992 10.654V18.3269H12.3992V10.654H10.8992ZM11.2919 17.6675L6.35929 20.3406L7.07398 21.6594L12.0066 18.9863L11.2919 17.6675ZM7.46664 21V10.8059H5.96664V21H7.46664Z",
    fill: "#FF5F14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOrange);
export default __webpack_public_path__ + "static/media/FilterOrange.57744efe15de407af345b11ee12d6d75.svg";
export { ForwardRef as ReactComponent };